// All coordinates are in real-world inches so artwork scales truthfully against furniture.
const person = (x, floor, fill = "#3b342c") => (
  <g fill={fill} opacity="0.55">
    <circle cx={x} cy={floor - 62} r={4.5} />
    <rect x={x - 6} y={floor - 56} width={12} height={26} rx={4} />
    <rect x={x - 5.5} y={floor - 31} width={4.5} height={31} rx={1.5} />
    <rect x={x + 1} y={floor - 31} width={4.5} height={31} rx={1.5} />
  </g>
);

export const ROOM_SCENES = [
  {
    key: "living", label: "Living Room", W: 180, H: 108, artBottom: 48, artCenterX: 90, scaleNote: "Sofa 84 in wide",
    wall: "#efe6d8", floor: "#b99a74",
    draw: (f) => (
      <g>
        <rect x={48} y={f - 34} width={84} height={18} rx={3} fill="#8a6f57" />
        <rect x={44} y={f - 22} width={92} height={10} rx={2} fill="#7a5f48" />
        <rect x={44} y={f - 12} width={92} height={4} fill="#5e4736" />
        <rect x={46} y={f - 8} width={3} height={8} fill="#4a3627" /><rect x={131} y={f - 8} width={3} height={8} fill="#4a3627" />
        <rect x={54} y={f - 31} width={17} height={13} rx={2} fill="#c9b79a" /><rect x={109} y={f - 31} width={17} height={13} rx={2} fill="#c9b79a" />
        <rect x={148} y={f - 24} width={20} height={24} fill="#5e4736" />
        <rect x={153} y={f - 58} width={2} height={34} fill="#5e4736" /><path d={`M144 ${f - 58} h20 l-3 -12 h-14 z`} fill="#e8dcc6" />
        <rect x={14} y={f - 14} width={14} height={14} fill="#a88c6a" />
        <path d={`M21 ${f - 14} c-14 -12 -6 -30 0 -36 c6 6 14 24 0 36z`} fill="#6c7f55" />
        <path d={`M21 ${f - 14} c-16 -4 -18 -22 -14 -30 c8 4 14 18 14 30z`} fill="#7d8f63" />
      </g>
    ),
  },
  {
    key: "lobby", label: "Hotel Lobby", W: 240, H: 144, artBottom: 72, artCenterX: 120, scaleNote: "Reception desk 120 in wide",
    wall: "#e3ddd2", floor: "#8f8378",
    draw: (f) => (
      <g>
        <rect x={60} y={f - 42} width={120} height={42} fill="#3a3430" />
        <rect x={58} y={f - 44} width={124} height={3} fill="#c9a56a" />
        <rect x={0} y={f - 2} width={240} height={2} fill="#6b6057" />
        {[40, 200].map(x => (
          <g key={x}>
            <rect x={x - 0.5} y={0} width={1} height={28} fill="#7d7266" />
            <path d={`M${x - 9} 28 h18 l-4 12 h-10 z`} fill="#f2e8d3" />
          </g>
        ))}
        <rect x={12} y={f - 18} width={30} height={18} fill="#6d5a4a" />
        <rect x={198} y={f - 18} width={30} height={18} fill="#6d5a4a" />
        {person(52, f, "#2b2622")}
      </g>
    ),
  },
  {
    key: "office", label: "Office", W: 160, H: 108, artBottom: 40, artCenterX: 80, scaleNote: "Desk 60 in wide",
    wall: "#e9ebe6", floor: "#9aa0a3",
    draw: (f) => (
      <g>
        <rect x={50} y={f - 30} width={60} height={2.5} fill="#5a4b3f" />
        <rect x={52} y={f - 27.5} width={3} height={27.5} fill="#3c3c3c" /><rect x={105} y={f - 27.5} width={3} height={27.5} fill="#3c3c3c" />
        <rect x={68} y={f - 48} width={24} height={15} rx={1} fill="#1f2326" />
        <rect x={78} y={f - 33} width={4} height={3} fill="#3c3c3c" /><rect x={73} y={f - 30.5} width={14} height={1} fill="#3c3c3c" />
        <rect x={70} y={f - 46} width={20} height={11} fill="#3d5a6c" />
        <rect x={68} y={f - 34} width={24} height={12} rx={3} fill="#2a2a2a" />
        <rect x={62} y={f - 22} width={20} height={4} rx={1} fill="#222" /><rect x={71} y={f - 18} width={2} height={14} fill="#222" />
        <rect x={20} y={f - 60} width={20} height={60} fill="#7c6a58" />
        {[f - 45, f - 30, f - 15].map(y => <rect key={y} x={22} y={y} width={16} height={1.5} fill="#5a4b3f" />)}
        <rect x={128} y={f - 12} width={12} height={12} fill="#a88c6a" />
        <path d={`M134 ${f - 12} c-10 -10 -4 -26 0 -30 c4 4 10 20 0 30z`} fill="#6c7f55" />
      </g>
    ),
  },
  {
    key: "restaurant", label: "Restaurant", W: 160, H: 108, artBottom: 50, artCenterX: 80, scaleNote: "Table 36 in wide",
    wall: "#5c4a3e", floor: "#3b2f27",
    draw: (f) => (
      <g>
        <rect x={62} y={f - 30} width={36} height={2} fill="#e6dccb" />
        <rect x={78} y={f - 28} width={4} height={26} fill="#2a211c" /><rect x={70} y={f - 3} width={20} height={3} fill="#2a211c" />
        <rect x={72} y={f - 31} width={5} height={1.5} fill="#f4efe6" /><rect x={84} y={f - 31} width={5} height={1.5} fill="#f4efe6" />
        <rect x={79} y={f - 37} width={2} height={7} fill="#f1e2b5" />
        {[44, 106].map(x => (
          <g key={x} fill="#8a6f57">
            <rect x={x} y={f - 36} width={10} height={20} rx={1} />
            <rect x={x - 1} y={f - 18} width={12} height={2} />
            <rect x={x} y={f - 16} width={1.5} height={16} /><rect x={x + 8.5} y={f - 16} width={1.5} height={16} />
          </g>
        ))}
        <rect x={29.5} y={0} width={1} height={22} fill="#2a211c" /><path d={`M22 22 h16 l-3 8 h-10 z`} fill="#d9b36a" />
        <rect x={0} y={f - 36} width={160} height={1.5} fill="#8a6f57" opacity="0.6" />
      </g>
    ),
  },
  {
    key: "hotelroom", label: "Hotel Room", W: 180, H: 108, artBottom: 42, artCenterX: 90, scaleNote: "Queen bed 60 in wide",
    wall: "#e8e1d3", floor: "#8c7a68",
    draw: (f) => (
      <g>
        <rect x={58} y={f - 42} width={64} height={24} rx={3} fill="#5b4c40" />
        <rect x={60} y={f - 24} width={60} height={12} fill="#f5f1ea" />
        <rect x={60} y={f - 18} width={60} height={18} fill="#a58e75" />
        <rect x={62} y={f - 22} width={56} height={5} fill="#d8cdbc" />
        <rect x={66} y={f - 31} width={20} height={7} rx={2} fill="#faf8f3" /><rect x={94} y={f - 31} width={20} height={7} rx={2} fill="#faf8f3" />
        {[30, 128].map(x => (
          <g key={x}>
            <rect x={x} y={f - 24} width={22} height={24} fill="#6d5a4a" />
            <rect x={x + 10} y={f - 40} width={2} height={16} fill="#4a3627" /><path d={`M${x + 4} ${f - 40} h14 l-2 -8 h-10 z`} fill="#f2e8d3" />
          </g>
        ))}
      </g>
    ),
  },
  {
    key: "cafe", label: "Coffee Shop", W: 160, H: 108, artBottom: 42, artCenterX: 80, scaleNote: "Counter 96 in wide",
    wall: "#d9c9b2", floor: "#6b5442",
    draw: (f) => (
      <g>
        <rect x={32} y={f - 38} width={96} height={38} fill="#3f3128" />
        <rect x={30} y={f - 40} width={100} height={3} fill="#b08a5a" />
        {[40, 56, 72, 88, 104, 120].map(x => <rect key={x} x={x} y={f - 36} width={1} height={34} fill="#2a211c" />)}
        <rect x={98} y={f - 54} width={20} height={14} rx={2} fill="#bfb6a8" /><rect x={100} y={f - 56} width={16} height={2} fill="#8d867b" />
        <rect x={120} y={f - 45} width={4} height={5} fill="#f4efe6" /><rect x={126} y={f - 45} width={4} height={5} fill="#f4efe6" />
        <rect x={46} y={f - 50} width={14} height={10} rx={5} fill="#f4efe6" /><circle cx={50} cy={f - 47} r={2} fill="#a3583a" /><circle cx={56} cy={f - 47} r={2} fill="#5b3a2a" />
        {[148].map(x => (
          <g key={x} fill="#2a211c"><circle cx={x + 4} cy={f - 30} r={5} /><rect x={x + 3} y={f - 28} width={2} height={28} /></g>
        ))}
        {person(20, f, "#3b342c")}
      </g>
    ),
  },
];
